export default {
  SSN: {
    color: "#2220A9",
    bg: "#DCD6FE",
  },
  SDEP: {
    color: "#167C3C",
    bg: "#D8FDEC",
  },
  FORM: {
    color: "#7C033C",
    bg: "#FDD2DC",
  },
  open: {
    color: "#3BC97E",
    bg: "#3BC97E20",
  },
  closed: {
    color: "#E14170",
    bg: "#FFF4F7",
  },
  available: {
    color: "#027A48",
    bg: "#ECFDF3",
  },
  "coming soon": {
    color: "#363F72",
    bg: "#F8F9FC",
  },
  publish: {
    color: "#8674FA",
    bg: "#EDEBFF",
    title: "Published",
  },
  draft: {
    color: "#B4B0D1",
    bg: "#E6E5F1",
    title: "draft",
  },
};
